<script setup lang="ts">
import TypePhone from '@/shared/components/Contact/ContactType/TypePhone.vue';
import { CONTACTS } from '@/shared/constants/ContactType';
import { useContactDetailsStore } from '@/shared/stores/ContactDetailStore';
import ClickToCall from '@/shared/components/Buttons/ClickToCall.vue';
import DirectMessage from '@/shared/components/ContactBox/Buttons/DirectMessage.vue';
import GiveRating from '@/shared/components/ContactBox/Buttons/GiveRating.vue';
import { storeToRefs } from 'pinia';
import { ContactHelper } from '@/shared/helper/ContactHelper';
import { useBaseRatingStore } from '@/shared/stores/BaseRatingStore';
import { useSettingsStore } from '@/shared/stores/SettingsStore';

const { canReceiveMessages } = useSettingsStore();
const { rating } = storeToRefs(useBaseRatingStore());
const { modifiedContactDetails } = storeToRefs(useContactDetailsStore());
const { phoneNumbers } = ContactHelper();
</script>

<template>
  <div
    :class="canReceiveMessages || (rating.isRateable && rating.ratingCount !== 0) ? 'gap-4 xl:!pt-4' : 'lg:gap-4'"
    class="pb-4 pt-0 md:ps-0 xl:px-4 xl:border-t xl:border-neutral-200 flex md:flex-col-reverse md:grow lg:flex-row-reverse xl:flex-col items-center md:max-w-fit lg:max-w-none xl:items-stretch flex-shrink-0 md:items-end md:justify-center lg:items-center lg:justify-start">
    <div class="w-full md:w-auto flex flex-row-reverse xl:flex-col gap-2.5 lg:gap-4">
      <DirectMessage />
      <ClickToCall />
      <GiveRating />
    </div>
    <TypePhone
      class="self-center md:self-center hidden md:flex"
      :data-contact-id="modifiedContactDetails[0]?.id"
      :data-contact-key="CONTACTS.PHONE_NUMBER"
      :data-contact-value="phoneNumbers(0).phoneNumber || modifiedContactDetails[0].phoneNumber">
    </TypePhone>
  </div>
</template>
